<template>
  <div class="columns">
    <div class="column is-three-quarters ">
      <admin-section-header icon="arrow-up" :title="$t('Productos')" />
      <dashboard-banner-tile
        title=""
        subtitle=""
        :blur="false"
        ctaText=""
        ctaTarget="admin.onBoard.list"
        backgroundImage="https://elitek-s3.s3.amazonaws.com/2021-02-12-shutterstock_1490142176.jpg"
      >
        <img
          style="visibility: hidden;"
          src="https://elitek-s3.s3.amazonaws.com/2021-02-12-shutterstock_1490142176.jpg"
        />
        <b-button
          size="is-large"
          style="position: absolute; left: 50%; top: 54%;"
          type="is-primary"
          >{{ $t('Acceder') }}</b-button
        >
      </dashboard-banner-tile>
    </div>
    <div class="column is-one-quarter twitter">
      <TwitterFeed profile="bopinion" />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import TwitterFeed from '@/components/admin/dasboard/TwitterFeed.vue'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'

export default {
  components: { TwitterFeed, AdminSectionHeader, DashboardBannerTile },
  mounted() {},
  data() {
    return {}
  },
  methods: {
    ...mapActions('onBoard', ['getOnboardRequests'])
  }
}
</script>

<style scoped>
.columns {
  margin-top: 0;
  overflow: hidden;
}
.column.twitter,
.solicitudes-table {
  overflow: scroll;
}
</style>
